<template>
  <div style="display: contents">
    <v-card
      flat
      width="100%"
      height="100%"
      class="d-flex justify-center align-center"
      color="transparent"
    >
      <section>
        <template>
          <v-container
            v-if="endmsg"
            :style="`background-color: ${hexToRGB('#FBFBFBFF', 0.5)}`"
          >
            <v-card
              class="d-flex align-end py-6 flex-column"
              outlined
              tile
              color="transparent"
              :style="`
          min-height: 30px;
          height: auto !important; /* for IE as it does not support min-height */
          height: 30px;
          font-size: ${endform_theme.text_size}px;
        `"
            >
              <v-card class="pa-0 ma-0" width="100%" flat color="transparent">
                <v-container>
                  <v-sheet ref="chatbox" color="transparent">
                    <v-row v-for="(message, index) in endmsg" :key="index">
                      <v-col cols="12" class="py-0">
                        <v-card
                          :class="`d-flex mb-2 justify-${endform_theme.text_justify} align-center`"
                          flat
                          tile
                          color="transparent"
                        >
                          <div
                            v-if="message.type === 'image'"
                            class="d-flex pa-0 ma-0 my-2 align-center"
                          >
                            <v-card
                              color="transparent"
                              class="d-flex justify-center"
                              flat
                              tile
                            >
                              <img
                                :src="message.payload.url"
                                :width="
                                  mobile_mode
                                    ? '100%'
                                    : TabletSize
                                    ? '100%'
                                    : '50%'
                                "
                              />
                            </v-card>
                          </div>
                          <div
                            v-else-if="message.type === 'video'"
                            class="d-flex pa-0 ma-0 my-2 align-center"
                          >
                            <v-card
                              color="transparent"
                              class="d-flex justify-center"
                              flat
                              tile
                            >
                              <video
                                width="200"
                                controls
                                :src="message.payload.url"
                              >
                                Your browser does not support the video tag.
                              </video>
                            </v-card>
                          </div>
                          <div v-else class="d-flex pa-0 ma-0 align-center">
                            <v-card
                              class="rounded"
                              color="transparent"
                              flat
                              tile
                              :style="{
                                'white-space': 'pre-line',
                                'word-break': ' break-word',
                                color: endform_theme.text_color,
                              }"
                            >
                              {{ message.payload.text }}
                            </v-card>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-container>
              </v-card>
            </v-card>
            <v-card
              v-if="endform_theme.image"
              class="d-flex justify-center my-10"
              flat
              color="transparent"
            >
              <img
                :src="endform_theme.image_url"
                alt=""
                :width="endform_theme.image_size"
              />
            </v-card>
            <v-card
              v-if="!once"
              class="d-flex justify-center my-10"
              flat
              color="transparent"
            >
              <v-btn
                :color="endform_theme.button.bg_color"
                :style="`color: ${endform_theme.button.text_color}`"
                :text="endform_theme.button.bt_texttype === 'text'"
                :outlined="endform_theme.button.bt_texttype === 'outlined'"
                :block="endform_theme.button.bt_block"
                :rounded="endform_theme.button.bt_rounded"
                style="font-size: 16px"
                @click="!config ? DoQuestionAgain() : false"
                >{{ endform_theme.button.text }}</v-btn
              >
            </v-card>
            <v-card
              v-else-if="
                once &&
                (($route.query.socialType === 'ONECHAT' &&
                  $route.query.socialID) ||
                  $route.query.socialType === 'ONEPLATFORM') &&
                $route.query.token
              "
              class="d-flex justify-center my-10"
              flat
              color="transparent"
            >
              <v-btn color="#395DA5FF" @click="CloseQuestion" dark
                >ปิดแบบสอบถาม</v-btn
              >
            </v-card>
          </v-container>
        </template>
      </section>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
export default {
  props: ["config", "endform_theme", "qselect", "mobile_mode"],
  data() {
    return {
      endmsg: null,
      once: false,
    };
  },
  created() {
    if (this.$route.query) {
      this.getQuestion(this.$route.query.questionID);
    }
  },
  watch: {
    qselect(newValue, oldValue) {
      if (newValue) {
        if (newValue !== oldValue) {
          this.getQuestion(newValue);
        }
      }
    },
  },
  methods: {
    hexToRGB(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    },
    getQuestion(qid) {
      if (qid) {
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${
            this.config
              ? this.$route.params.surveyID
              : this.$route.query.surveyID
          }/question/questioninfo/${qid}`,
          data: {},
        };
        this.$store.getters.SendAPIWithHeader(api).then((response) => {
          if (response.data.questionType === "end") {
            this.endmsg = response.data.questions;
            this.$cookies.remove(
              process.env.VUE_APP_COOKIE +
                "_" +
                this.$route.query.surveySession +
                "_questionStep"
            );
            this.$cookies.remove(
              process.env.VUE_APP_COOKIE +
                "_" +
                this.$route.query.surveySession +
                "_answerStep"
            );
            if (!this.config) {
              this.$store
                .dispatch(
                  "getSurveyByID",
                  this.config
                    ? this.$route.params.surveyID
                    : this.$route.query.surveyID
                )
                .then((response) => {
                  this.once = response.data.enableOneTime;
                })
                .catch(() => {
                  Swal.fire({
                    icon: "error",
                    text: "ไม่สามารถดึงข้อมูล survey ได้",
                    title: "",
                  });
                });
            }
          }
        });
      }
    },
    DoQuestionAgain() {
      if (this.$route.query.shared_token) {
        let param = {
          surveyID: this.$route.query.surveyID,
        };
        if (this.$route.query.shared_token) {
          param.shared_token = this.$route.query.shared_token;
        }
        if (this.$route.query.socialType) {
          param.socialType = this.$route.query.socialType;
        }
        if (this.$route.query.token) {
          param.token = this.$route.query.token;
        }
        if (this.$route.query.socialID) {
          param.socialID = this.$route.query.socialID;
        }
        this.$router.push({
          name: "startform",
          query: param,
        });
      } else {
        this.$router.push({
          name: "startform",
          query: {
            surveyID: this.$route.query.surveyID,
          },
        });
      }
    },
    CloseQuestion() {
      let jwtdata = jwtDecode(this.$route.query.shared_token);
      if (this.$route.query.socialType) {
        if (
          this.$route.query.socialType === "ONECHAT" &&
          this.$route.query.token &&
          this.$route.query.socialID
        ) {
          let jwtdataonechat = jwtDecode(jwtdata.access_token);
          this.$axios.post(
            "https://chat-api.one.th/message/api/v2/disable_webview",
            {
              user_id: jwtdataonechat.sub,
              bot_id: this.$route.query.socialID,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (
          this.$route.query.socialType === "ONEPLATFORM" &&
          this.$route.query.token
        ) {
          this.$axios.post(
            "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
            {
              one_id: jwtdata.sub,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (this.$route.query.socialType === "FACEBOOK") {
          Swal.fire({
            html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "รับทราบ",
          });
        }
      }
    },
  },
  computed: {
    TabletSize() {
      const { smAndDown } = this.$vuetify.breakpoint;
      return smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped></style>
